export default __webpack_public_path__ + "static/media/tea-setup.42aa7ed5.jpg";